import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=2b97ac24&"
import script from "./Connections.vue?vue&type=script&lang=js&"
export * from "./Connections.vue?vue&type=script&lang=js&"
import style0 from "./Connections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports